
















































































































































































































































































































import Vue from 'vue';

import contentManager from './contentManager.vue';

import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCDialog } from '@material/dialog';
import { MDCSnackbar } from '@material/snackbar';

import { Post } from './posts.vue';
import postComponent from '../../post.vue';

import UUID from 'uuid/v4';
import Axios from 'axios';

interface Data {
  date: InternalDate;
  post: Post;
  setup: Setup;
  delConfDialog: MDCDialog;
  inputs: MDCTextField[];
  ripples: MDCRipple[];
}

interface InternalDate {
  date: Date;
  day: number;
  month: number;
  year: number;
}

interface Setup {
  dialog: MDCDialog;
  snackbarFail: MDCSnackbar;
  snackbarSuccess: MDCSnackbar;
}

export default Vue.extend({
  name: 'blog',
  data(): Data {
    const date = new Date();
    const post = new Post();
    post.ImageID = '';
    post.Title = 'Title';
    post.SubTitle = 'Sub Title';
    post.Paragraphs = [
      'This is the first paragraph',
    ];

    return {
      date: {
        date,
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      },
      post,
      setup: {} as Setup,
      inputs: [],
      ripples: [],
      delConfDialog: {} as MDCDialog,
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id === 'new') {
      this.post.ID = UUID();
      const newURL = this.$route.path.replace('new', this.post.ID);
      this.$router.replace({ path: newURL });
    } else {
      this.post.ID = id;
      const v = this;
      Axios.get('/API/admin/post/' + this.post.ID).then((resp) => {
        // Convert returned data to Post type
        const post = resp.data as Post;

        // Save the date and set the input to match the wanted date
        v.date.date = new Date(post.Date);

        v.date.day = v.date.date.getDate();
        v.date.month = v.date.date.getMonth() + 1;
        v.date.year = v.date.date.getFullYear();

        // Save date as Date object
        post.Date = new Date(v.date.date);
        // Save the post
        v.post = post;

      }).catch((err) => {
        console.error(err);
      });
    }

    const buttons = this.$el.querySelectorAll('.mdc-button') as NodeListOf<HTMLElement>;
    for (const button of buttons) {
      const buttonRipple = new MDCRipple(button);
    }

    let textField = new MDCTextField(this.$el.querySelector('.mdc-text-field.title') as HTMLElement);
    textField = new MDCTextField(this.$el.querySelector('.mdc-text-field.subTitle') as HTMLElement);

    this.initTextFields();

    this.setup.dialog = new MDCDialog(this.$el.querySelector('.image .mdc-dialog') as HTMLElement);
    this.delConfDialog = new MDCDialog(this.$el.querySelector('.buttons .mdc-dialog') as HTMLDivElement);

    this.setup.snackbarFail = new MDCSnackbar(this.$el.querySelector('.mdc-snackbar.fail') as HTMLElement);
    this.setup.snackbarSuccess = new MDCSnackbar(this.$el.querySelector('.mdc-snackbar.success') as HTMLElement);
  },
  destroyed() {
    this.setup.dialog.destroy();
    this.setup.snackbarFail.destroy();
    this.setup.snackbarSuccess.destroy();
    this.delConfDialog.destroy();
    for (const el of this.inputs) {
      el.destroy();
    }
    for (const el of this.ripples) {
      el.destroy();
    }
  },
  methods: {
    initTextFields() {
      const textlements = this.$el.querySelectorAll('.mdc-text-field') as NodeListOf<HTMLElement>;
      for (const dateInput of textlements) {
        const textField = new MDCTextField(dateInput);
        this.inputs.push(textField);
      }

      const paragraphElements = this.$el.querySelectorAll('.mdc-text-field.paragraph') as NodeListOf<HTMLElement>;
      for (const para of paragraphElements) {
        const paraMDC = new MDCRipple(para);
        this.ripples.push(paraMDC);
      }
    },
    updateParagraph(index: number) {
      const txt = this.post.Paragraphs[index];
      if (txt) {
        return;
      }

      if (this.post.Paragraphs.length === 1) {
        this.post.Paragraphs = [] as string[];
      } else {
        const v = this as any;
        this.post.Paragraphs = this.post.Paragraphs.filter((p: string) => {
          if (p === v.post.Paragraphs[index]) {
            return false;
          }
          return true;
        });
      }
    },
    addParagraph() {
      this.post.Paragraphs.push('New empty paragraph');
    },
    setSetImageSeletor() {
      this.setup.dialog.open();
    },
    imageSelected(id: string) {
      this.post.ImageID = id;
      this.setup.dialog.close();
    },
    removeImage() {
      this.post.ImageID = '';
    },
    savePost() {
      const setup = this.setup as Setup;
      Axios.put('/API/admin/post', this.post)
        .then((resp) => {
          setup.snackbarSuccess.open();
        })
        .catch((err: any) => {
          setup.snackbarFail.open();
        });
    },
    openDelPostConf() {
      this.delConfDialog.open();
    },
    delPost() {
      const v = this as any;
      Axios.delete('/API/admin/post/' + this.post.ID).then((resp) => {
        this.$router.push('/postManagement');
      }).catch((err: any) => {
        v.setup.snackbar.open();
      });
    },
    dateUpdated() {
      this.date.date = new Date(this.date.year, this.date.month - 1, this.date.day);
      this.post.Date = this.date.date;
    },
  },
  components: {
    contentManager,
    postComponent,
  },
});
